class TrustpilotWidget extends HTMLElement {
  static scriptLoadedPromise = null;

  connectedCallback() {
    if (TrustpilotWidget.scriptLoadedPromise) {
      TrustpilotWidget.scriptLoadedPromise.then(() => {
        console.log("Script already loaded.");
      })
        .catch(() => {
          console.error('Script not loaded');
        });
      return;
    }

    TrustpilotWidget.scriptLoadedPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";

      script.onload = () => {
        resolve();
      };

      script.onerror = () => {
        console.log("Failed to load script.");
        reject();
      };

      document.head.appendChild(script);
    }).catch(() => {
      console.error('Script not loaded');
    });
  }
}

customElements.define('trustpilot-widget', TrustpilotWidget);
